import { useDocsDataModelStore } from '@/models/docs-data/docsData';
import {
  loadEnvironmentVariablesInURLByDocsId,
  saveEnvironmentVariablesInURLByDocsId,
} from '@/shared/constant/local-storage/use-environment/UseEnvironmentInSearchStorage';
import { urlSearchToCachedObject } from '@/ui-kit/components/utils/urlSearchParamsToObject';
import { useSearchParams } from '@remix-run/react';
import { useEffect, useMemo } from 'react';

export const useSearchVariablesInURL = () => {
  const [urlSearchParams] = useSearchParams();
  const searchParamsInRecords = useMemo(
    () => urlSearchToCachedObject(urlSearchParams),
    [urlSearchParams],
  );

  const docsId = useDocsDataModelStore((x) => x.docsIdTypeData.onlineId);
  const setSearchVariablesInURLPrepared = useDocsDataModelStore(
    (x) => x.setSearchVariablesInURLPrepared,
  );

  useEffect(() => {
    const lastEnvironmentVariablesInURL = loadEnvironmentVariablesInURLByDocsId(docsId) || [];
    const environmentVariablesInURL = searchParamsInRecords?.environment;
    if (
      !environmentVariablesInURL ||
      (Array.isArray(environmentVariablesInURL) && environmentVariablesInURL.length <= 0)
    ) {
      return;
    }
    const newKey = environmentVariablesInURL.map((item) => item[0]);
    saveEnvironmentVariablesInURLByDocsId(docsId, [
      ...lastEnvironmentVariablesInURL.filter((item) => !newKey.includes(item[0])),
      ...environmentVariablesInURL,
    ]);
    setSearchVariablesInURLPrepared(true);
  }, [docsId, searchParamsInRecords, setSearchVariablesInURLPrepared]);
};
